var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{staticClass:"expandable-column",attrs:{"colspan":_vm.$parent.columnLength + 1}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }